import React from "react";

import Web3 from "web3";
import Web3Modal from "web3modal";
import WalletConnectProvider from "@walletconnect/web3-provider";
import BigNumber from "bignumber.js";
//import tableData from "../data";
import CONTRACT from "./contracts"

const HASHGUISE_CONTRACT = '0x797844b651c8220d8dcd4099d1c9bfc9e24bf3ca'

class WebConnect extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      web3: null,
      addressConnected: 'Connect',
      totalMinted: "Locked",
      mintPrice: '0.05',
    }

    setInterval(() => {
      this.onChangeData()
    }, 10000);
  }

  disconnect () {
    this.state = {
      web3: null,
      addressConnected: 'Connect',
      totalMinted: "Locked",
      mintPrice: '0.05',
    }
  }

  getAddress(){
    if(this.state.addressConnected == 'Connect')
      return this.state.addressConnected

    return '0x' + this.state.addressConnected[2] + this.state.addressConnected[3] + this.state.addressConnected[4] +
      '...' + this.state.addressConnected[this.state.addressConnected.length - 3] + this.state.addressConnected[this.state.addressConnected.length - 2]
      + this.state.addressConnected[this.state.addressConnected.length - 1]
  }

  async onWeb3Connect (prov){
    const providerOptions = {
      walletconnect: {
        package: WalletConnectProvider,
        options: { infuraId: "99a833caa93445b488506442552de208" },
      }
    };

    const web3Modal = new Web3Modal({
      network: "mainnet",
      cacheProvider: false,
      providerOptions,
    });

    const provider = await web3Modal.connectTo(prov);
    const _web3 = new Web3(provider);
    window.send = (e,t) => { return provider.send(e,t) }
    this.state.web3 = _web3
    await this.onChangeData()
  };

  async onChangeData() {
    if(this.state.web3){
      const accounts = await this.state.web3.eth.getAccounts();
      let addrConnected = accounts[0]
      this.state.addressConnected =  addrConnected

      let hashguise_contract = new this.state.web3.eth.Contract(CONTRACT['CONTRACT'][HASHGUISE_CONTRACT], HASHGUISE_CONTRACT);

      try{
        var res = await Promise.all([
          hashguise_contract.methods.totalSupply().call(),
          hashguise_contract.methods.balanceOf(addrConnected).call(),
        ])
      } catch(e){
        console.log(e);
        return
      }

      this.state.totalMinted = res[0]
      this.state.balance = res[1]
    }
  }

  async mint(amount){
      try{
        console.log(amount)
        if(amount > 10 || amount <= 0)
          return

        let gasAmount = new BigNumber(277000).plus((amount - 1) * 150000)
        var mint_price = new BigNumber(this.state.mintPrice).times(Math.pow(10,18)).times(amount).toFixed()
        let hashguise_contract = new this.state.web3.eth.Contract(CONTRACT['CONTRACT'][HASHGUISE_CONTRACT], HASHGUISE_CONTRACT);

        var step_1 = await hashguise_contract.methods.mint(amount)
        this.state.inProcess = true;
        var res = await step_1.send({from: this.state.addressConnected, value: mint_price})
        this.state.inProcess = false;
        this.onChangeData()
        return res.transactionHash
      } catch (e) {
        console.log(e)
        return null
      }
  }

}

export default (new WebConnect());
